import type { Entity } from '@models/Entity'

import { request } from '../../../gateways/api'
import type { Activiteit } from '../types//Activiteit'
import type { ActiviteitenEntitySearch } from '../types/ActiviteitenEntitySearch'

export { searchActiviteitenForEntity, initialState }

const initialState: ActiviteitenEntitySearch = {
  data: [],
}

const searchActiviteitenForEntity = async ({
  entity: { type, id },
}: {
  entity: Entity
}) => {
  const result = await request<Activiteit[]>({
    url: `/rest/${type}/${id}/activiteit/search`,
    method: 'POST',
  })

  return result
}
